import React from 'react';
import { isNull, isUndefined } from 'lodash';
import { useSelector } from 'react-redux';
import { selectIsFrontline, selectIsHospital } from '@components/Auth';

import { Loading, LoadingError } from '@components/Base';
import { HealthQuoteBenefitScheduleCardBody } from '@components/Feature/HealthQuote';
import { QuoteDocumentCardBody, QuoteExclusionCardBody } from '@components/Feature/Quote';
import { FeatureCardBody } from '@components/HealthQuoteBuyRoute/HealthQuoteReviewPage/feature-card-body';
import { UserCardBody } from '@components/CorporateHealthQuoteBuyRoute/CorporateHealthQuoteBuyReviewPage/user-card-body';
import { ImportCardBody } from '@components/CorporateHealthQuoteBuyRoute/CorporateHealthQuoteBuyReviewPage/import-card-body';

import { useCorporateHealthOrderFetch } from './hook';
import { OrderableCard } from '../orderable-card';

const CorporateHealthPolicyDetails = () => {
  const corporateHealthOrder = useCorporateHealthOrderFetch();
  const isFrontline = useSelector(selectIsFrontline);
  const isHospital = useSelector(selectIsHospital);

  if (isUndefined(corporateHealthOrder)) return <Loading />;
  if (isNull(corporateHealthOrder)) return <LoadingError />;

  return (
    <OrderableCard {...corporateHealthOrder}>
      {!isHospital && <FeatureCardBody {...corporateHealthOrder} />}
      <HealthQuoteBenefitScheduleCardBody {...corporateHealthOrder} />
      <QuoteExclusionCardBody {...corporateHealthOrder} />
      {!isHospital && <QuoteDocumentCardBody {...corporateHealthOrder} />}
      {isFrontline && <ImportCardBody {...corporateHealthOrder} />}
      {!isHospital && <UserCardBody {...corporateHealthOrder} />}
    </OrderableCard>
  );
};

export { CorporateHealthPolicyDetails };
